import { digitsFromStr } from '../util/strings';

export const formatPhone = (input: string): string => {
    const parsed = digitsFromStr(input);
    const matches = parsed
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

    if (!matches) {
        return parsed;
    }

    if (!matches[2]) {
        return matches[1];
    }

    return `(${matches[1]}) ${matches[2]}${matches[3] ? '-' + matches[3] : ''}`;
};
